import React from 'react';
import { notificationBaseStyle, notificationCloseStyle } from './styles';
import { ISmartProps } from './types';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { CloseButtonComponent } from '../../Utilities/utils/CloseButtonComponent';
import * as meta from '../../meta-data.json';

export const overrides = (props: ISmartProps) => {
	const HTMLAttrs = getHTMLAttributes(props);
	const kindNotification = props.theme;
	const { shadow } = props;
	return {
		Body: {
			style: ({ $theme }: any) => {
				return {
					...notificationBaseStyle(kindNotification, shadow, $theme),
				};
			},
			props: {
				'data-epo': `epo-notification-${meta.version}`,
				part: `epo-notification-${meta.version}`,
				className: props.className,
				...HTMLAttrs.dataProps,
				...HTMLAttrs.ariaProps,
				...getBaseCustomProps(props),
				id: props.id,
			},
		},
		InnerContainer: {
			style: () => {
				return {
					width: 'calc(100% - 22px)',
				};
			},
		},
		CloseIcon: {
			component: (restProps: any) => <CloseButtonComponent style={notificationCloseStyle} {...restProps} />,
		},
	};
};
